import React from "react";
import { Loading } from "@folio/stripes/components";
import { FormattedMessage } from "react-intl";
import css from "./TableLoadingOverlay.module.css";
export var TableLoadingOverlay = function (_a) {
    var visible = _a.visible;
    if (!visible) {
        return null;
    }
    return (React.createElement("div", { className: css.overlay, "data-test-table-loading": true },
        React.createElement("div", { className: css.box },
            React.createElement(Loading, { size: "large" }),
            React.createElement("span", { className: css.label },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.table.loading" })))));
};
